import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
////// Mui
import { useTheme, useMediaQuery } from '@mui/material';
////// Store
import { getItems } from '../../../redux/slices/noteTermSlice';
////// Controls & Components
import { columnsTermsOfPayment } from '../Tables/Columns/columnsTermsOfPayment';
import TableSimple from '../Tables/TableSimple';

const TermsOfPayment = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const smMediaDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [updatedColumns, setFilteredColumns] = React.useState(columnsTermsOfPayment());
  const { noteTerms, statusNoteTerms } = useSelector((state) => state.noteTermSlice);

  React.useEffect(() => {
    if (noteTerms.length < 1 && statusNoteTerms === null) {
      dispatch(getItems());
    }
  }, [noteTerms, statusNoteTerms, dispatch]);

  React.useEffect(() => {
    if (smMediaDown) {
      let updatedColumns = columnsTermsOfPayment().filter(
        (column) => column.id === 'note_short' || column.id === 'note_description'
      );
      setFilteredColumns(updatedColumns);
    } else {
      setFilteredColumns(columnsTermsOfPayment());
    }
  }, [smMediaDown, setFilteredColumns]);

  return (
    <>
      <TableSimple
        resource="terms-of-payment"
        popupTitle={t('popup.title.payment_term')}
        columns={updatedColumns}
        data={noteTerms}
        addButtonText={t('button.add_payment_term')}
      />
    </>
  );
};

export default TermsOfPayment;
